import React, {useMemo, useRef, useState} from 'react'
import UserImageCircle from '../../../components/UserImageCircle'
import {Affix, Radio} from "antd";
import ProjectPosition from '../../../models/ProjectPosition';
import {usePosition} from "../../../providers/ProjectPositionProvider";
import User from "../../../models/User";
import ChangeOrderItemImpactPanel from "./ChangeOrderItemImpactPanel";
import SpinLoader from "../../../components/SpinLoader";
import {useAuth} from "../../../providers/AuthProvider";
import {useMount} from "react-use";

import Form from '../../../components/form/Form'
import { ChangeOrderDocuments } from './ChangeOrderItemForm';

const {TypeTimeline, TypeRate, TypeCandidate} = ProjectPosition.ChangeOrderTypes;
const typeLabels = {
    Timeline: 'Timeline Change',
    Rate: 'Rate/Cost Change',
    Candidate: 'Resource Swap'
}
const TaxTypes = {
    1: '1099',
    2: 'W2',
}
const TimelineChangeFields = ({orderItem, ...props}) => {
    const {auth} = useAuth();
    const canManageClients = auth.canManageClients();

    const lastCandidateSegment = useMemo(() => {
        let segment = TB.last(orderItem.candidate_segments);
        if (segment?.candidate?.user) {
            segment.candidate.user = User.make(segment.candidate?.user)
        }
        return segment
    }, [orderItem])

    console.log('TimelineChangeFields', orderItem)
    return (
        <div className="flex flex-col gap-4 pb-2 mb-4">
            <p className="font-semibold">Contract Terms</p>

            <div className="flex flex-row items-start gap-3">
                <div className="flex-1">
                    <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                        Talent Resource
                    </p>
                    <div className="pt-1.5 flex items-stretch flex-col">

                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            <UserImageCircle user={lastCandidateSegment?.candidate?.user}/>
                            <p>
                                {lastCandidateSegment?.candidate?.user.fullName()}
                            </p>
                        </div>
                    </div>
                </div>
                {canManageClients && (
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Tax Classification
                        </p>
                        <div className="pt-1.5 flex items-stretch flex-col">

                            {lastCandidateSegment?.candidate && (
                                <p className="pt-1.5">
                                    {TaxTypes[lastCandidateSegment?.candidate?.tax_type]}
                                </p>
                            )}
                        </div>
                    </div>
                )}
                <div className="flex-1">
                    <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                        Start Date
                    </p>
                    <div className="pt-1.5 flex items-stretch flex-col">

                        {lastCandidateSegment?.started_at && (
                            <p className="pt-1.5">
                                {TB.moment(lastCandidateSegment?.started_at).format('MMM Do, YYYY')}
                            </p>
                        )}
                    </div>
                </div>
                {!canManageClients && (
                    <div className="flex-1"/>
                )}
            </div>
            <div className="flex flex-row items-start gap-3">
                <div className="flex-1">
                    <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                        Original End Date
                    </p>
                    <div className="pt-1.5 flex items-stretch flex-col">

                        {orderItem.original_ended_at && (
                            <p className="pt-1.5">
                                {TB.moment(orderItem.original_ended_at).format('MMM Do, YYYY')}
                            </p>
                        )}
                    </div>
                </div>

                <div className="flex-1">
                    <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                        New End Date
                    </p>
                    <div className="pt-1.5 flex items-stretch flex-col">

                        <p className="pt-1.5">
                            {TB.moment(orderItem.new_ended_at).format('MMM Do, YYYY')}
                        </p>

                    </div>
                </div>
                <div className="flex-1"/>
            </div>
            <div className="flex flex-row items-start gap-3">

                <div className="flex-1">
                    <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                        Total Hours
                    </p>

                    <div className="pt-1.5 flex items-stretch flex-col">

                        <p className="pt-1.5">
                            {orderItem.original_total_periods || '-'}
                        </p>

                    </div>
                </div>
                <div className="flex-1">
                    <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                        New Total Hours
                    </p>
                    <div className="pt-1.5 flex items-stretch flex-col max-w-[200px]">

                        <div className="pt-1.5 flex items-stretch flex-col">

                            <p className="pt-1.5">
                                {orderItem.new_total_periods || '-'}
                            </p>

                        </div>
                    </div>
                </div>
                <div className="flex-1"/>
            </div>
            <div className="flex flex-row items-start gap-3">

                {canManageClients && (
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Talent Hourly Rate
                        </p>
                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                ${TB.formatNumber(orderItem.new_rate, 2)} / hr
                            </div>
                        </div>
                    </div>
                )}
                {canManageClients && (
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Percent Markup
                        </p>

                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                {parseFloat(Number(orderItem.new_percent_markup).toFixed(4))}
                            </div>
                        </div>
                    </div>
                )}
                <div className="flex-1">
                    <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                        Assigned Bill Rate
                    </p>

                    <div className="pt-1.5 flex flex-row items-center gap-2">
                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            ${TB.formatNumber(orderItem.new_platform_rate, 2)} / hr
                        </div>
                    </div>
                </div>

                {!canManageClients && (
                    <React.Fragment>
                        <div className="flex-1">
                            <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                                Contract Value
                            </p>

                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <div className="pt-1.5 flex flex-row items-center gap-2">
                                    <span className="flex flex-row items-center gap-3">
                                        {Number(orderItem.original_contract_value)
                                            .toFixed(2) !== Number(orderItem.new_contract_value)
                                            .toFixed(2) && (
                                            <span
                                                className="text-danger line-through">${TB.formatNumber(orderItem.original_contract_value, 2)}</span>
                                        )}
                                        <span>${TB.formatNumber(orderItem.new_contract_value, 2)}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="flex-1"/>
                    </React.Fragment>
                )}
            </div>
            {canManageClients && (
                <div className="flex flex-row items-start gap-3">
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Resource Cost
                        </p>

                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <span className="flex flex-row items-center gap-3">
                                    {Number(orderItem.original_talent_cost)
                                        .toFixed(2) !== Number(orderItem.new_talent_cost)
                                        .toFixed(2) && (
                                        <span
                                            className="text-danger line-through">${TB.formatNumber(orderItem.original_talent_cost, 2)}</span>
                                    )}
                                    <span>${TB.formatNumber(orderItem.new_talent_cost, 2)}</span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Platform Fee
                        </p>

                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <span className="flex flex-row items-center gap-3">
                                    {Number(orderItem.original_platform_fee)
                                        .toFixed(2) !== Number(orderItem.new_platform_fee)
                                        .toFixed(2) && (
                                        <span
                                            className="text-danger line-through">${TB.formatNumber(orderItem.original_platform_fee, 2)}</span>
                                    )}
                                    <span>${TB.formatNumber(orderItem.new_platform_fee, 2)}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Contract Value
                        </p>

                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <span className="flex flex-row items-center gap-3">
                                    {Number(orderItem.original_contract_value)
                                        .toFixed(2) !== Number(orderItem.new_contract_value)
                                        .toFixed(2) && (
                                        <span
                                            className="text-danger line-through">${TB.formatNumber(orderItem.original_contract_value, 2)}</span>
                                    )}
                                    <span>${TB.formatNumber(orderItem.new_contract_value, 2)}</span>
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            )}

        </div>
    )
}

const CandidateRateChangeFields = ({orderItem, ...props}) => {
    const {auth} = useAuth();
    const canManageClients = auth.canManageClients();

    const lastCandidateSegment = useMemo(() => {
        let totalSegments = orderItem.candidate_segments?.length;
        if (totalSegments && totalSegments > 1) {
            //Get second to last segment
            let segment = orderItem.candidate_segments[totalSegments - 2];
            if (segment?.candidate?.user) {
                segment.candidate.user = User.make(segment.candidate?.user)
            }
            return segment
        }
        return {};
    }, [orderItem])

    const newCandidateSegment = useMemo(() => {
        let segment = TB.last(orderItem.candidate_segments);
        if (segment?.candidate?.user) {
            segment.candidate.user = User.make(segment.candidate?.user)
        }
        return segment
    }, [orderItem])

    return (
        <React.Fragment>
            <div className="flex flex-col gap-4 pb-2 mb-4">
                <p className="font-semibold">Previous Contract Terms</p>

                <div className="flex flex-row items-start gap-3">
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Talent Resource
                        </p>
                        <div className="pt-1.5 flex items-stretch flex-col">

                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <UserImageCircle user={lastCandidateSegment.candidate.user}/>
                                <p>
                                    {lastCandidateSegment.candidate.user.fullName()}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Start Date
                        </p>
                        <div className="pt-1.5 flex items-stretch flex-col">

                            {lastCandidateSegment.started_at && (
                                <p className="pt-1.5">
                                    {TB.moment(lastCandidateSegment.started_at).format('MMM Do, YYYY')}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className="flex-1"/>
                </div>
                <div className="flex flex-row items-start gap-3">
                    {canManageClients && (
                        <div className="flex-1">
                            <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                                Original Hourly Rate
                            </p>
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <div className="pt-1.5 flex flex-row items-center gap-2">
                                    ${TB.formatNumber(orderItem.original_rate, 2)} / hr
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Original Bill Rate
                        </p>
                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                ${TB.formatNumber(orderItem.original_platform_rate, 2)} / hr
                            </div>
                        </div>
                    </div>
                    {canManageClients && (
                        <div className="flex-1">
                            <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                                Original Percent Markup
                            </p>

                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <div className="pt-1.5 flex flex-row items-center gap-2">
                                    <span className="flex flex-row items-center gap-3">
                                        <span>{parseFloat(Number(orderItem.original_percent_markup * 100)
                                            .toFixed(4))}%
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    {!canManageClients && (
                        <React.Fragment>
                            <div className="flex-1"/>
                            <div className="flex-1"/>
                        </React.Fragment>
                    )}
                </div>


                <div className="flex flex-row items-start gap-3">
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Original End Date
                        </p>
                        <div className="pt-1.5 flex items-stretch flex-col">

                            {orderItem.original_ended_at && (
                                <p className="pt-1.5">
                                    {TB.moment(orderItem.original_ended_at).format('MMM Do, YYYY')}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            End Date for Old Rate
                        </p>
                        <div className="pt-1.5 flex items-stretch flex-col">

                            {orderItem.effective_at && (
                                <p className="pt-1.5">
                                    {TB.moment(orderItem.effective_at).format('MMM Do, YYYY')}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className="flex-1"/>
                </div>


                <div className="flex flex-row items-start gap-3">

                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Original Est. Hours
                        </p>

                        <div className="pt-1.5 flex items-stretch flex-col">

                            <p className="pt-1.5">
                                {orderItem.original_total_periods || '-'}
                            </p>

                        </div>
                    </div>
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            New Est. Hours for Old Rate
                        </p>
                        <div className="pt-1.5 flex items-stretch flex-col">

                            <p className="pt-1.5">
                                {lastCandidateSegment?.total_periods || '-'}
                            </p>

                        </div>
                    </div>
                    <div className="flex-1"/>
                </div>
                <div className="flex flex-row items-start gap-3">
                    {canManageClients && (
                        <div className="flex-1">
                            <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                                Old Rate Resource Cost
                            </p>

                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <div className="pt-1.5 flex flex-row items-center gap-2">
                                    <span className="flex flex-row items-center gap-3">
                                        {Number(orderItem.original_talent_cost)
                                            .toFixed(2) !== Number(lastCandidateSegment.talent_cost).toFixed(2) && (
                                            <span
                                                className="text-danger line-through">${TB.formatNumber(orderItem.original_talent_cost, 2)}</span>
                                        )}
                                        <span>${TB.formatNumber(lastCandidateSegment.talent_cost, 2)}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    {canManageClients && (
                        <div className="flex-1">
                            <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                                Old Rate Platform Fee
                            </p>

                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <div className="pt-1.5 flex flex-row items-center gap-2">
                                    <span className="flex flex-row items-center gap-3">
                                        {Number(orderItem.original_platform_fee)
                                            .toFixed(2) !== Number((lastCandidateSegment.platform_cost) - (lastCandidateSegment.talent_cost))
                                            .toFixed(2) && (
                                            <span
                                                className="text-danger line-through">${TB.formatNumber(orderItem.original_platform_fee, 2)}</span>
                                        )}
                                        <span>${TB.formatNumber((lastCandidateSegment.platform_cost) - (lastCandidateSegment.talent_cost), 2)}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Old Rate Contract Value
                        </p>

                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <span className="flex flex-row items-center gap-3">
                                    {Number(orderItem.original_contract_value)
                                        .toFixed(2) !== Number(lastCandidateSegment.platform_cost).toFixed(2) && (
                                        <span
                                            className="text-danger line-through">${TB.formatNumber(orderItem.original_contract_value, 2)}</span>
                                    )}
                                    <span>${TB.formatNumber(lastCandidateSegment.platform_cost, 2)}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    {!canManageClients && (
                        <React.Fragment>
                            <div className="flex-1"/>
                            <div className="flex-1"/>
                        </React.Fragment>
                    )}
                </div>
            </div>
            <div className="flex flex-col gap-4 pb-2 mb-4">
                <p className="font-semibold">New Contract Terms</p>

                <div className="flex flex-row items-start gap-3">
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Talent Resource
                        </p>
                        <div className="pt-1.5 flex items-stretch flex-col">

                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <UserImageCircle user={newCandidateSegment.candidate.user}/>
                                <p>
                                    {newCandidateSegment.candidate.user.fullName()}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Start Date
                        </p>
                        <div className="pt-1.5 flex items-stretch flex-col">

                            {newCandidateSegment.started_at && (
                                <p className="pt-1.5">
                                    {TB.moment(newCandidateSegment.started_at).format('MMM Do, YYYY')}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className="flex-1"/>
                </div>
                <div className="flex flex-row items-start gap-3">

                    {canManageClients && (
                        <div className="flex-1 inline-flex flex-col items-stretch">
                            <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                                New Talent Rate
                            </p>
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <div className="pt-1.5 flex flex-row items-center gap-2">
                                    ${TB.formatNumber(orderItem.new_rate, 2)} / hr
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="flex-1 inline-flex flex-col items-stretch">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            New Bill Rate
                        </p>
                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                ${TB.formatNumber(orderItem.new_platform_rate, 2)} / hr
                            </div>
                        </div>
                    </div>
                    {canManageClients && (
                        <div className="flex-1">
                            <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                                New Rate Percent Markup
                            </p>

                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <div className="pt-1.5 flex flex-row items-center gap-2">
                                    <span className="flex flex-row items-center gap-3">
                                        <span>{parseFloat(Number(orderItem.new_percent_markup * 100)
                                            .toFixed(4))}%
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    {!canManageClients && (
                        <React.Fragment>
                            <div className="flex-1"/>
                            <div className="flex-1"/>
                        </React.Fragment>
                    )}
                </div>


                <div className="flex flex-row items-start gap-3">

                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            End Date for New Rate
                        </p>
                        <div className="pt-1.5 flex items-stretch flex-col">

                            {orderItem.new_ended_at && (
                                <p className="pt-1.5">
                                    {TB.moment(orderItem.new_ended_at).format('MMM Do, YYYY')}
                                </p>
                            )}
                        </div>

                    </div>


                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            Est. Hours for New Rate
                        </p>
                        <div className="pt-1.5 flex items-stretch flex-col">

                            <p className="pt-1.5">
                                {orderItem.affected_periods || '-'}
                            </p>

                        </div>
                    </div>
                    <div className="flex-1"/>

                </div>
                <div className="flex flex-row items-start gap-3">
                    {canManageClients && (
                        <div className="flex-1">
                            <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                                New Rate Resource Cost
                            </p>

                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <div className="pt-1.5 flex flex-row items-center gap-2">
                                    <span className="flex flex-row items-center gap-3">

                                        <span>${TB.formatNumber(newCandidateSegment?.talent_cost, 2)}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    {canManageClients && (
                        <div className="flex-1">
                            <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                                New Rate Platform Fee
                            </p>

                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <div className="pt-1.5 flex flex-row items-center gap-2">
                                    <span className="flex flex-row items-center gap-3">

                                        <span>${TB.formatNumber(newCandidateSegment?.platform_cost - newCandidateSegment?.talent_cost, 2)}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="flex-1">
                        <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                            New Rate Contract Value
                        </p>

                        <div className="pt-1.5 flex flex-row items-center gap-2">
                            <div className="pt-1.5 flex flex-row items-center gap-2">
                                <span className="flex flex-row items-center gap-3">
                                    <span>
                                        ${TB.formatNumber(newCandidateSegment.platform_cost, 2)}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    {!canManageClients && (
                        <React.Fragment>
                            <div className="flex-1"/>
                            <div className="flex-1"/>
                        </React.Fragment>
                    )}
                </div>
            </div>
        </React.Fragment>
    )
}

const ChangeOrderItemView = ({order, readOnly, onClose, onSubmit, isDisabled}) => {
    const formRef = useRef(null);
    const {auth} = useAuth();
    const {position} = usePosition();

    const [orderItem, setOrderItem] = useState(TB.find(order.items, ['position_id', position.id]))


    const [formModel, setFormModel] = useState(() => {
        if(orderItem.latest_contract) {
            orderItem.contract = orderItem.latest_contract;
        }
        if(orderItem.latest_signed_contract) {
            orderItem.signed_contract = orderItem.latest_signed_contract;
        }
        return orderItem;
    })
    
    useMount(() => {
        console.log('ChangeOrderItem', orderItem)
    })


    const hasFileChanged = useMemo(() => {
        return !TB.isEqual(formModel.contract, orderItem.latest_contract) || !TB.isEqual(formModel.signed_contract, orderItem.latest_signed_contract)
    }, [formModel])

    const handleSubmit = async () => {
        onSubmit(formModel)
    }

    const typeOptions = [
        {
            label: typeLabels[orderItem.type],
            value: orderItem.type,
            style: {lineHeight: '35px', height: 35}
        }
    ]

    return (
        <SpinLoader isLoading={isDisabled}>
            <div className="bg-white text-left">

                <div className="change-order-form-container">
                    <div className="flex gap-4">

                        <div className="w-2/3 flex flex-col gap-3">
                            <div className="flex flex-col gap-4 pb-6 border-b border-wripplePrimaryRuleBlue mb-4">
                                <p className="font-semibold">
                                    Item Details
                                </p>
                                <div className="flex flex-col">
                                    <div className="flex flex-row gap-4">
                                        <div className="flex-grow">
                                            <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue mb-2.5">
                                                Order Type
                                            </p>

                                            <div className="pointer-events-none">
                                                <Radio.Group
                                                    options={typeOptions}
                                                    readOnly={true}
                                                    disabled={isDisabled}
                                                    value={orderItem.type}
                                                    buttonStyle="solid"
                                                    optionType="button"/>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {orderItem.type === TypeTimeline ?
                                <TimelineChangeFields orderItem={orderItem}/> :
                                <CandidateRateChangeFields orderItem={orderItem}/>
                            }
                        </div>

                        <Affix
                            offsetTop={20}
                            target={document.querySelector('.ant-drawer-body') ? () => document.querySelector('.ant-drawer-body') : undefined}
                            className="flex-grow mt-10">
                            <ChangeOrderItemImpactPanel item={orderItem}/>
                        </Affix>
                    </div>

                    {/* Only Client Leads should see change order documents (for now) */}

                    {auth.isClientConsultant() && (
                        <Form
                            ref={formRef}
                            className="change-order-form-container"
                            onSubmit={handleSubmit}
                            submitButton={false}
                            background={"none"}
                            isDisabled={isDisabled}
                            model={formModel}
                            onChange={async (model) => {
                                let updatedFormModel = {...formModel};
        
                                for (let [key, value] of Object.entries(model)) {
                                    updatedFormModel = TB.set(updatedFormModel, key, value);
                                }
        
                                console.log(updatedFormModel, 'updatedFormModel')
                                await setFormModel(updatedFormModel)
                            }}
                            fields={[]}
                        >

                            <ChangeOrderDocuments
                                formModel={formModel}
                                isDisabled={isDisabled}
                                readOnly={readOnly}
                            />

                            {(readOnly || !hasFileChanged) ? (
                                <div className="flex justify-end gap-4 pt-4 border-t border-wripplePrimaryRuleBlue">
                                    <button type="button" onClick={onClose} className="btn btn-outline-primary">
                                        Close
                                    </button>
                                </div>
                            ) : (
                                <div className="flex justify-end gap-4 pt-4 border-t border-wripplePrimaryRuleBlue">
                                    <button type="submit" className="btn btn-primary">
                                        Save
                                    </button>

                                    <button type="button" onClick={onClose} className="btn btn-outline-primary">
                                        Cancel
                                    </button>
                                </div>
                            )}
                        </Form>
                    )}

                    {!auth.isClientConsultant() && (
                        <div className="flex justify-end gap-4 pt-4 border-t border-wripplePrimaryRuleBlue">
                            <button type="button" onClick={onClose} className="btn btn-outline-primary">
                                Close
                            </button>
                        </div>
                    )}
                </div>

            </div>
        </SpinLoader>
    )
}

export default ChangeOrderItemView;